module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAWCAYAAAD5Jg1dAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAACHSURBVHja7JE7CgJBEAVrFyPxAAYexEjwSh7GyJuYeQQxFz+gJxBMtkxWbBsHJzKyoOFBF/PhoRJmrK7Uo9oZyNLJAi0vFsCEAoOQZx/2V+CWxWGSNsAc6ABaypyf0jfxjUZd93kKjNL7dn2+N6oVB+5rr77UiofYzDaVsYzNVf/6L/5YfAwA6zN+pa0GWfwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/page-footer/page-png/facebook.png
// module id = ./src/components/page-footer/page-png/facebook.png
// module chunks = index